import Button from '@material-ui/core/Button'
import Checkbox from '@material-ui/core/Checkbox'
import CircularProgress from '@material-ui/core/CircularProgress'
import FormControl from '@material-ui/core/FormControl'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Input from '@material-ui/core/Input'
import InputLabel from '@material-ui/core/InputLabel'
import Paper from '@material-ui/core/Paper'
import { withStyles } from '@material-ui/core/styles'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import {
    deleteBookingOrganization,
    fetchBookingOrganizations,
    postBookingOrganization,
    updateBookingOrganization
} from '../../../../../api/bookingApi/bookingOrganizations'
import {
    selectOrganizations,
    selectOrganizationsFetching
} from '../../../../../selectors/bookingSelectors/bookingOrganizations'
import { selectEasymsOrganizationsKV } from '../../../../../selectors/easymsOrganizationSelector'
import OrganizationsTable from './OrganizationTable'
import SelectWithSearch from './SelectWithSearch'

const styles = theme => ({
    root: {
        flexGrow: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
    },
    paper: {
        padding: theme.spacing.unit * 2,
        textAlign: 'center',
        color: theme.palette.text.secondary
    },
    container: {
        display: 'flex',
        flexWrap: 'wrap'
    },
    formControl: {
        margin: theme.spacing.unit,
        width: 250
    },
    button: {
        margin: theme.spacing.unit
    },
    progress: {
        margin: theme.spacing.unit * 2
    }
})

class OrganizationTab extends Component {
    static propTypes = {
        classes: PropTypes.object.isRequired,
        organizations: PropTypes.array.isRequired,
        fetching: PropTypes.bool.isRequired,
        fetchBookingOrganizations: PropTypes.func.isRequired,
        postBookingOrganization: PropTypes.func.isRequired,
        deleteBookingOrganization: PropTypes.func.isRequired,
        updateBookingOrganization: PropTypes.func.isRequired,
        easymsOrganizationsKV: PropTypes.array.isRequired
    }

    state = {
        ourId: '',
        remoteId: '',
        remoteName: '',
        active: false
    }

    componentDidMount() {
        const params = { size: 1000 }
        this.props.fetchBookingOrganizations(params)
    }

    handleChange = e => {
        this.setState({ [e.target.name]: e.target.value })
    }

    handleSelect = prop => event => {
        this.setState({ [prop]: event.target.value })
    }

    handleCheck = name => event => {
        this.setState({ [name]: event.target.checked })
    }

    handleClick = () => {
        const { ourId, remoteId, remoteName, active } = this.state
        this.props.postBookingOrganization({
            ourId,
            remoteId: remoteId.trim(),
            remoteName: remoteName.trim(),
            active
        })
        this.setState({
            ourId: '',
            remoteId: '',
            remoteName: '',
            active: false
        })
    }

    handleDelete = remoteId => {
        this.props.deleteBookingOrganization(remoteId)
    }

    handleUpdate = organization => {
        this.props.updateBookingOrganization(organization.remoteId, { ...organization })
    }

    mergeOrganizations = (organizations, easymsOrganizationsKV) => {
        return organizations.map(org => {
            const match = easymsOrganizationsKV.find(opt => opt.value === org.ourId)

            if (!match) {
                return { ...org, ourName: null }
            }

            // label without last (id: )
            const label = match.label.replace(/\([^()]*\)\s*$/, '').trim()

            return {
                ...org,
                ourName: label
            }
        })
    }

    render() {
        const { classes, fetching, organizations, easymsOrganizationsKV } = this.props
        const { ourId, remoteId, remoteName, active } = this.state
        const valid = ourId && remoteId.trim() && remoteName.trim()

        return (
            <div className={classes.root}>
                <Paper className={classes.paper}>
                    <FormControl className={classes.formControl}>
                        <SelectWithSearch
                            label="Організація EasyMS"
                            value={ourId}
                            onChange={this.handleSelect('ourId')}
                            options={easymsOrganizationsKV}
                        />
                    </FormControl>
                    <FormControl className={classes.formControl}>
                        <InputLabel htmlFor="org-remote-id">ID організації Booking.com</InputLabel>
                        <Input id="org-remote-id" name="remoteId" value={remoteId} onChange={this.handleChange} />
                    </FormControl>
                    <FormControl className={classes.formControl}>
                        <InputLabel htmlFor="org-remote-name">Назва організації Booking.com</InputLabel>
                        <Input id="org-remote-name" name="remoteName" value={remoteName} onChange={this.handleChange} />
                    </FormControl>
                    <FormControlLabel
                        control={<Checkbox checked={active} onChange={this.handleCheck('active')} value="active" />}
                        label="Активна"
                    />
                    <Button
                        disabled={!valid}
                        variant="raised"
                        color="primary"
                        className={classes.button}
                        onClick={this.handleClick}
                    >
                        Зберегти
                    </Button>
                </Paper>

                {fetching ? (
                    <CircularProgress className={classes.progress} />
                ) : (
                    <OrganizationsTable
                        organizations={this.mergeOrganizations(organizations, easymsOrganizationsKV)}
                        onDelete={this.handleDelete}
                        onUpdate={this.handleUpdate}
                    />
                )}
            </div>
        )
    }
}

export default connect(
    state => ({
        organizations: selectOrganizations(state),
        fetching: selectOrganizationsFetching(state),
        easymsOrganizationsKV: selectEasymsOrganizationsKV(state)
    }),
    { fetchBookingOrganizations, postBookingOrganization, updateBookingOrganization, deleteBookingOrganization }
)(withStyles(styles)(OrganizationTab))



// WEBPACK FOOTER //
// ./src/components/ChannelTabs/BookingTab/MappingTabs/OrganizationTab/OrganizationTab.js